export default __webpack_public_path__ + "static/media/es_LA.402bdedf.svg";